export default __webpack_public_path__ + "static/media/permeable-paving-manufacturers-banner.af544b85.jpg";